<template>
  <span :class="$style.discount"
    >{{ discount }}<IconSelect icon="flag" class="ml-1" :class="$style.discountIcon"
  /></span>
</template>

<script>
import IconSelect from '@/js/components/Shared/IconSelect/IconSelect.vue'

export default {
  name: 'DiscountBadge',
  components: {
    IconSelect,
  },
  props: {
    discount: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" module>
.discount {
  display: inline-block;
  padding: 2px 0.15rem 2px 0.4rem;

  color: var(--white);
  font-size: 0.85rem;

  background: var(--error);
  border-radius: 4px;
}

.discountIcon {
  width: 16px;
  height: 16px;

  vertical-align: text-bottom;
}
</style>
